/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPanelClosed = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M18.5 4h-13C4 4 4 5.5 4 5.5v13S4 20 5.5 20h13s1.5 0 1.5-1.5v-13S20 4 18.5 4m-3 14.5h3v-13h-3zM14 5.5H5.5v13H14z" clipRule="evenodd" /></svg>;
export default SvgPanelClosed;